import CheckoutCallbackSFC from "./CheckoutCallback.vue";
export const CheckoutCallback = CheckoutCallbackSFC;
